import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Spinner } from '../components/Loading';
import { FaTimesCircle } from 'react-icons/fa';

const PaymentCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying | success | failed
  const [message, setMessage] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    // Paystack appends ?reference=xxx&trxref=xxx ; we also passed orderId in callback
    const reference = searchParams.get('reference') || searchParams.get('trxref');
    const orderId = searchParams.get('orderId');

    if (!reference) {
      setStatus('failed');
      setMessage('No payment reference found.');
      return;
    }

    const verify = async () => {
      try {
        const res = await axios.get(`/api/payments/paystack/verify/${reference}`);
        if (res.data.success) {
          setStatus('success');
          const id = res.data.order?._id || orderId;
          // Brief pause so the user sees the success state, then go to confirmation
          setTimeout(() => navigate(`/order-confirmation/${id}`, { replace: true }), 1200);
        } else {
          setStatus('failed');
          setMessage(res.data.message || 'Your payment could not be confirmed.');
        }
      } catch (error) {
        setStatus('failed');
        setMessage(error.response?.data?.message || 'We could not verify your payment.');
      }
    };

    verify();
  }, [searchParams, navigate]);

  return (
    <div className="page">
      <div className="container" style={{ maxWidth: 520 }}>
        <div className="card" style={{ textAlign: 'center', padding: '56px 32px' }}>
          {status === 'verifying' && (
            <>
              <Spinner size={48} />
              <h2 style={{ fontFamily: 'var(--font-display)', marginTop: 24, marginBottom: 8 }}>
                Confirming your payment
              </h2>
              <p style={{ color: 'var(--gray-500)' }}>
                Please wait a moment — don't close this window.
              </p>
            </>
          )}

          {status === 'success' && (
            <>
              <div style={{
                width: 72, height: 72, borderRadius: '50%',
                background: 'var(--success-50)', color: 'var(--success-600)',
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 36, marginBottom: 18,
              }}>✓</div>
              <h2 style={{ fontFamily: 'var(--font-display)', marginBottom: 8 }}>Payment successful</h2>
              <p style={{ color: 'var(--gray-500)' }}>Redirecting you to your order...</p>
            </>
          )}

          {status === 'failed' && (
            <>
              <FaTimesCircle style={{ fontSize: 56, color: 'var(--danger-500)', marginBottom: 18 }} />
              <h2 style={{ fontFamily: 'var(--font-display)', marginBottom: 8 }}>Payment not completed</h2>
              <p style={{ color: 'var(--gray-500)', marginBottom: 24 }}>{message}</p>
              <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
                <Link to="/cart" className="btn btn-primary">Back to cart</Link>
                <Link to="/my-orders" className="btn btn-secondary">View my orders</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentCallback;
